<template>
    <div class="c-app flex-row align-items-center">
        <div class="login-page">
            <div class="form">
                <h3 class="headline" style="padding: 20px;">실버벨 관리자 </h3>
                <form class="login-form" @submit.prevent="LoginBtn">
                    <input type="id" placeholder="ID" v-model="id"/>
                    <input type="password" placeholder="Password" v-model="pass"/>
                    <button type="submit">login</button>
                    <p class="message"></p>
                </form>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .login {
        border: 1px solid black;
        border-radius: 5px;
        padding: 1.5rem;
        width: 300px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        .container-loading {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0,0,0,.3);
            img {
                width: 2rem;
                height: 2rem;
            }
        }
        form {
            display: flex;
            flex-flow: column;
            *:not(:last-child) {
                margin-bottom: 1rem;
            }
            input {
                padding: .5rem;
            }
            button {
                padding: .5rem;
                background-color: lightgray;
                border: 1px solid gray;
                border-radius: 3px;
                cursor: pointer;
                &:hover {
                    background-color: lightslategray;
                }
            }
        }
    }
</style>
<script>
    import { mapState, mapActions } from 'vuex';
    import axios from "axios";

    export default {
        data() {
            return {
                id: '',
                pass: ''
            }
        },
        computed: {
            ...mapState([
                'loggingIn',
                'loginError',
                'loginSuccessful'
            ])
        },
        methods: {
            ...mapActions([
                'doLogin',
                'fetchAccessToken'
            ]),
            /* loginSubmit() {
                 this.doLogin({
                     id: this.id,
                     pass: this.pass
                 })

                 if (localStorage.setItem('accessToken', response.data.token);) != 'undefined') {

                     alert(1);
                 }

             }*/
            LoginBtn(){
                this.doLogin({
                    id: this.id,
                    pass: this.pass
                })
                axios.get("/silver/login",{
                    params: { id: this.id, pass : this.pass },
                    timeout: 10000 // 1초 이내에 응답이 없으면 에러 처리
                })

                //성공일떄 실행
                    .then(res => {
                        // handle success
                        if(res.data.error == "0" || res.data.error == null){
                            alert("로그인정보가 일치 하지 않습니다.");
                            return;
                        } else {
                            var id = res.data.adminId;
                            this.$router.push({path: '/paymanage/list'})
                        }
                        console.log("res");
                    })

                    //에러일떄 실행
                    .catch(err => {
                        // handle error
                        console.log(err);
                        alert("로그인 실패");
                        console.log("err");
                    })
                    //무조건 실행
                    .then(() => {
                    });
            },
        }
    }


</script>
